import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/ru'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru')
// преобразование строки в нужных формат даты
// params shortType - дата в формате DD.MM.YYYY
// isOutputTime - вывод даты со временем

export function convertDataToStringWithMonth(
  date: string,
  shortType: boolean = false,
  isOutputTime: boolean = true,
): string {
  const dateValue = dayjs.tz(date, 'UTC').tz(dayjs.tz.guess())

  const time = isOutputTime ? dateValue.format('HH:mm') : ''

  if (shortType) {
    return dateValue.format('DD.MM.YYYY') + (time ? ` в ${time}` : '')
  }

  return dateValue.format('DD MMMM YYYY') + (time ? ` в ${time}` : '')
}
